// src/stores/useQuoteStore.js
import create from "zustand";

export const TecAssuredStore = create((set) => ({
	quoteData: null,
	setQuoteData: (data) => set({ quoteData: data }),
	createAgreementReqBody: { locationId: null, RatePackage: {} },
	setCreateAgreementReqBody: (data) => set({ createAgreementReqBody: data }),
	productPropertiesResp: null,
	setProductPropertiesResp: (data) => set({ productPropertiesResp: data }),
	agreementReqBody: null,
	setAgreementReqBody: (data) => set({ agreementReqBody: data }),

	// tecLocationID: 1234,
	// tecLocationID: 3245,
	// tecLocationID: 5456,
	tecLocationID: 4757,
	reset: () =>
		set({
			quoteData: null,
			createAgreementReqBody: { locationId: null, RatePackage: {} },
			productPropertiesResp: null,
			agreementReqBody: null,
		}),
}));
